import React from 'react';
import { Icons, List } from '@usepepper/sprout-kit-ui';
import { Pressable } from 'react-native';

const ROW_HEIGHT = 52;

interface OrderEntryMobileHeaderPanelListItemProps {
  disabled?: boolean;
  leading: React.ReactElement;
  onPress?: () => void;
  title: string;
}

export const OrderEntryMobileHeaderPanelListItem: React.FC<
  OrderEntryMobileHeaderPanelListItemProps
> = ({ disabled, leading, onPress, title }) => {
  const item = (
    <List.Item
      alignItems="center"
      height={ROW_HEIGHT}
      paddingHorizontal="$0"
      paddingVertical="$0"
    >
      <List.Item.Leading marginRight="$10">{leading}</List.Item.Leading>
      <List.Item.Content>
        <List.Item.Title fontSize="$md" fontWeight="$medium" numberOfLines={1}>
          {title}
        </List.Item.Title>
      </List.Item.Content>
      {onPress ? (
        <List.Item.Trailing marginLeft="$10">
          <Icons.ChevronRight color="$iconTertiary" size={18} />
        </List.Item.Trailing>
      ) : null}
    </List.Item>
  );

  if (!onPress && !disabled) {
    return item;
  }

  return (
    <Pressable
      accessibilityLabel={title}
      accessibilityRole="button"
      accessibilityState={{ disabled: Boolean(disabled) }}
      disabled={disabled}
      onPress={onPress}
    >
      {item}
    </Pressable>
  );
};
